







































import { Component, Inject, Vue } from "vue-property-decorator";
import { IContractProductProvider } from "@/models/providers/contractProduct";
import { ClientTemplateSlotCodes } from "@/data/enums/templates";

@Component({
  components: {
    "cprod-summary-row": () =>
      import(`@/components/app/global/contractProducts/cProdSummaryRow.vue`),
    "cprod-timeline": () =>
      import(`@/components/app/global/contractProducts/cProdTimeline.vue`),
    "cprod-breakdown": () =>
      import(`@/components/app/global/contractProducts/cProdBreakdown.vue`),
    "cprod-actions": () =>
      import(`@/components/app/global/contractProducts/cProdActions.vue`),
    "client-template-render-provider": () =>
      import(
        `@/components/app/global/templates/clientTemplateRenderProvider.vue`
      )
  }
})
export default class CProdOverview extends Vue {
  // Inject

  @Inject({ from: "contractProductProvider" })
  public readonly $cProdData!: () => IContractProductProvider;

  // Computed

  public get cProdData() {
    return this.$cProdData();
  }

  public get clientTemplateProps() {
    return {
      code: ClientTemplateSlotCodes.CONTRACT_PRODUCT_OVERVIEW,
      objectId: this.cProdData.contractProduct.id
    };
  }
}
